<template>
    <div class="assets-wrap">
        <z-scrollDiv class="bu-assets">
            <div class="cycle-title">{{ data.bonusCycleDetail | cycleStr }}</div>

            <div class="show-wrap">
                <!-- 奖金 -->
                <div class="show-item">
                    <div class="title">奖金</div>
                    <div class="num">{{ bonus_curr.current_currency_balance }}<span class="unit">{{ bonus_curr.currency_name }}</span></div>
                </div>

                <div class="show-item">
                    <div class="title">预算</div>
                    <div class="num">{{ bonus_curr.currency_budget }}<span class="unit">{{ bonus_curr.currency_name }}</span></div>
                </div>
            </div>

            <div class="list-wrap">
                <!-- 奖金 -->
                <div class="item">
                    <div class="title">
                        <img src="~src/assets/image/asset-icon-4.svg">
                        <span class="text">BU奖金明细</span>
                    </div>
                    <div class="func-btn">
                        <!-- <div class="front-btn blue" v-if="data.isApplyPostponeOpen" @click='delayApply()'>延期申请</div> -->
                        <div class="front-btn orange" v-if="data.isBonusDistributionOpen" @click ="do_bonusAssign">奖金分配</div>
                        <div class="front-btn green hollow" @click="link('bu-bonus-detail')">查看明细</div>
                    </div>
                </div>
                <!-- 预算 -->
                <div class="item">
                    <div class="title">
                        <img src="~src/assets/image/asset-icon-2.svg">
                        <span class="text">BU预算明细</span>
                    </div>
                    <div class="func-btn">
                        <div class="front-btn orange hollow" @click = "pop.budgetFlag = true">申请预算</div>
                        <div class="front-btn green hollow" @click="link('bu-budget-detail')">查看明细</div>
                    </div>
                </div>
                <!-- 职级 -->
                <div class="item">
                    <div class="title">
                        <img src="~src/assets/image/asset-icon-3.svg">
                        <span class="text">BU职级明细</span>
                        <span class="special" v-if="data.isPromOpen">当前可分配职级：{{ rank_num+'级' }}</span>
                    </div>
                    <div class="func-btn">
                        <div class="front-btn green" v-if="data.isPromOpen" @click="do_rankAssign">职级分配</div>
                        <div class="front-btn green hollow" @click="link('bu-pmt-detail')">查看明细</div>
                    </div>
                </div>
                <!-- 罚单 -->
                <div class="item">
                    <div class="title">
                        <img src="~src/assets/image/asset-icon-1.svg">
                        <span class="text">BU罚单明细</span>
                    </div>
                    <div class="func-btn">
                        <div class="front-btn green hollow" @click="link('bu-ticket-detail')">查看明细</div>
                    </div>
                </div>
            </div>


            <!--*********弹窗部分*********-->
            <!--奖金分配  -->
            <bonusShare @close="pop.bonusFlag = false" :showFlag="pop.bonusFlag" :assets="bonus_assign" @getInfo="getData"  ></bonusShare>
            <!--职级分配  -->
            <rankShare  @close="pop.pmtFlag = false" @getInfo="getData" :pmt="data.pmtLevelSummary" :showFlag="pop.pmtFlag"></rankShare>

            <!--申请预算-->
            <el-dialog v-form:budget @close="budgetClose()" :close-on-click-modal="false" title="预算申请" :visible.sync="pop.budgetFlag">
                <!-- <div class="form-item">
                    <div class="item-title must">快币类型：</div>
                    <div class="item-text">
                        <el-select v-tar="pop.budgetType" rule="noVal" v-model="pop.budgetType" placeholder="请选择">
                            <el-option v-for="item in budget_list" :key="item.currency_id" :label="item.currency_name" :value="item.currency_id">
                            </el-option>
                        </el-select> 
                    </div>
                </div> -->
                <div class="form-item">
                    <div class="item-title must">申请金额：</div>
                    <div class="item-text mid">
                        <el-input v-tar="pop.budgetAmount" rule="noVal number positive" v-model="pop.budgetAmount" placeholder="请输入数字">
                            <template slot="append">{{ task_curr.currency_name }}</template>
                        </el-input>
                    </div>
                </div>
                <div class="form-item">
                    <div class="item-title must">申请理由：</div>
                    <div class="item-wrap">
                        <textarea v-tar="pop.budgetReason" rule="reason" v-arg="['申请理由']" v-model="pop.budgetReason" placeholder="请输入申请理由"></textarea>
                    </div>
                </div>
        
                <div slot="footer" class="dialog-footer">
                    <el-button @click="pop.budgetFlag = false">取 消</el-button>
                    <el-button type="primary" :loading="pop.budget_loading" @click="confirm_budget">确认</el-button>
                </div>
            </el-dialog>

            <!--延期分配申请-->
            <el-dialog v-form:delay @close="delayClose()" :close-on-click-modal="false" title="延期申请" :visible.sync="pop.delayFlag">
                <div class="form-item">
                    <div class="item-title must">申请BU：</div>
                    <div class="item-text">{{ delay.bu_name }}</div>
                </div>
                <div class="form-item">
                    <div class="item-title must">申请周期：</div>
                    <div class="item-text">{{ delay.cycle_detail && `${delay.cycle_detail.cycle_year}#${delay.cycle_detail.cycle_number}` }}</div>
                </div>
                <div class="form-item">
                    <div class="item-title must">申请理由：</div>
                    <div class="item-wrap">
                        <textarea v-tar="pop.delayReason" rule="reason" v-arg="['申请理由']" v-model="pop.delayReason" placeholder="请输入申请理由"></textarea>
                    </div>
                </div>
        
                <div slot="footer" class="dialog-footer">
                    <el-button @click="pop.delayFlag = false">取 消</el-button>
                    <el-button type="primary" :loading="pop.delay_loading" @click="confirm_delay">提交申请</el-button>
                </div>
            </el-dialog>

        </z-scrollDiv>
    </div>
</template>

<script>
    // import slider from "src/components/asset-slider.vue";
    import bonusShare from "./bonusShare.vue";
    import rankShare from "./rankShare.vue";
    
    import { mapGetters } from "vuex"

    export default {
        components:{
            // slider,
            bonusShare,
            rankShare,
        },
        data(){
            return {
                data:{},
                pop:{
					budgetFlag: false,  //申请预算  弹窗
					// budgetType: "",      //申请预算  快币类型
					budgetAmount: "",       //申请预算  金额
					budgetReason: "",   //申请预算  理由
					budget_loading: false,  //申请预算 确认判断器

					delayFlag: false,  //申请延期分配  弹窗
					delayReason: "",   //申请延期分配  理由
					delay_loading: false,  //申请延期分配 确认判断器

					bonusFlag:false,  //奖金分配 弹窗
					pmtFlag:false,   //职级分配 弹窗

                },
                delay:{},  //延期申请的展示数据
                
            }
        },
        computed:{
            ...mapGetters(['task_curr']),
            bonus_list(){
                return this.data.bonusCurrAccountInfoList || [];
            },
            budget_list(){
                return this.data.budgetCurrAccountInfoList || [];
            },
            bonus_curr(){
                return this.bonus_list[0] || {};
            },
            budget_curr(){
                return this.budget_list[0] || {};
            },
            bonus_assign(){  //可分配的快币
                return this.bonus_list.filter(item=>{
                    return item.dist_balance > 0;
                });
            },
            rank_num(){  //可分配的职级
                return this.data.pmtLevelSummary && `${this.data.pmtLevelSummary.balance}` || 0;
            },

            // cycle_text(){  //周期名称
            //     let data = this.data;
            //     return data.bonusCycleDetail && `${data.bonusCycleDetail.cycle_year}#${data.bonusCycleDetail.cycle_number}`
            // }

        },

        created(){
            this.getData();
        },

        methods:{
            link(name){
                this.$router.push({
                    name:name,
                });
            },
            getData(){
                let url = `api/manage/asset_info`;
                this.$http.get(url).then(res=>{
                    if(res.status == 200){
                        this.data = res.res_data;
                    }
                })
            },

            //****弹窗功能部分****
            do_bonusAssign(){  //奖金分配判断
                if(this.bonus_assign.length==0){
                    this.errorTip('没有可分配的奖金');
                    return;
                }
                this.pop.bonusFlag = true;
            },
            do_rankAssign(){
                if(this.rank_num == 0){
                    this.errorTip('没有可分配的职级');
                    return;
                }
                this.pop.pmtFlag = true;
            },

			// 延期申请
			delayClose(){  //清除数据
				this.pop.delayReason = "";
				this.$form.clear("delay");
			},
			confirm_delay(){ //延期申请 确认
				let res = this.$form.check("delay");
				console.log(`验证结果： ${res}`);
				if (!res) {
					return;
				}

				let config={
					cycle_detail_id:this.delay.cycle_detail.id,
					remark:this.pop.delayReason,
				}

				this.pop.delay_loading = true;
				this.$http.post("api/manager/curr_trans_req",config).then(res=>{
                    if(res.status ==200){
                        this.successTip("申请发送成功");
                        this.getData();
					    this.pop.delayFlag = false;
                    }
					this.pop.delay_loading = false;
				}).catch(error=>{
					this.errorTip("出错了");
					this.pop.delay_loading = false;
				});

            },
            // delayApply(){  //获取展示信息
            //     let url = `api/manager/curr_trans_req/info`;
            //     this.$http.get(url).then(res=>{
            //         if(res.status == 200){
            //             this.delay = res.res_data;
            //             console.log(res.res_data);
            //         }
            //     });
            //     this.pop.delayFlag = true;
            // },
            
			// 预算申请
			budgetClose(){  //清除数据
				// this.pop.budgetType = "";
				this.pop.budgetAmount = "";
				this.pop.budgetReason = "";
				this.$form.clear("budget");
			},
			confirm_budget(){  //申请预算 确认
				let res = this.$form.check("budget");
				if (!res) {
					return;
				}

				let config={
					trans_amount:parseInt(this.pop.budgetAmount),
					// currency_id:this.pop.budgetType,
					currency_id:this.task_curr.id,
					remark:this.pop.budgetReason,
				}

				this.pop.budget_loading = true;
				this.$http.post("api/manager/curr_bgt_req",config).then(res=>{
                    if(res.status == 200){
                        this.successTip("申请发送成功");
                        this.pop.budgetFlag = false;
                    }
					this.pop.budget_loading = false;
				}).catch(error=>{
					this.errorTip("出错了");
					this.pop.budget_loading = false;
				});

			},
        }

    }
</script>

<style lang="less">
    @import "~src/assets/less/var.less";
    @adjust:20px;  //顶部周期绿字位置调整
    @align:30px;  //对齐值


    @color_1:#00b993;
    @color_2:#6471a4;

    .assets-wrap{
        background:#fff;
        box-shadow:0 0 4px 0 rgba(127,127,127,0.50);
        height:calc(~"100% - @{adjust}");
        margin-top: @adjust;
    }
    .bu-assets{
        height:100%;
        // max-width: calc(~"@{screen} - @{front_side_w} - 2*@{front_padd}");
        position: relative;
        box-sizing: border-box;
        padding:0 30px;
        // 头部周期标题
        .cycle-title{
            font-size:16px;
            color:@main-c;
            position:absolute;
            left: 0;
            top:-@adjust - 10px;
        }

        // 展示模块
        .show-wrap{
            border-bottom: 1px solid #d8d8d8;
            .clear();
            .show-item{
                // padding:15px 0;
                // border-bottom: 1px solid #d8d8d8;
                // text-align: right;
                // position: relative;
                // min-height:50px;
                position: relative;
                height:200px;
                width:50%;
                float: left;
                .title{
                    position: absolute;
                    left: 0;
                    top:0;
                    @w:96px;
                    @h:56px;
                    width:@w;
                    height:@h;
                    line-height: 56px;
                    text-align: center;
                    font-size:16px;
                    font-weight:600;
                    color: #fff;
                    &:after{
                        content:"";
                        position: absolute;
                        display: block;
                        box-sizing: border-box;
                        bottom: 0;
                        left: 50%;
                        transform: translateX(-50%);
                        width:0;
                        height:0;
                        border-left: @w/2 solid transparent;
                        border-right: @w/2 solid transparent;
                        border-bottom: 10px solid #fff;

                    }
                }

                .num{
                    font-size: 32px;
                    position: absolute;
                    top:50%;
                    left: 50%;
                    transform: translate(-50%,-50%);
                    font-weight: 600;
                    .unit{
                        font-size: 14px;
                        font-weight: 500;
                    }
                }



                // 颜色循环
                .loop(@counter) when (@counter > 0) {
                    .loop(@counter - 1);
                    &:nth-of-type(@{counter}){
                        .title{
                            background:~"@{color_@{counter}}";
                        }

                        .num{
                            color: ~"@{color_@{counter}}";
                        }

                        // .slider-view{
                        //     .slider-item{
                        //         border-color: ~"@{color_@{counter}}";
                        //         .head{
                        //             background:~"@{color_@{counter}}";
                        //         }
                        //         .main{
                        //             color:~"@{color_@{counter}}";
                        //         }
                        //     }
                        // }
                    }
                }
                .loop(2);
            }
        }

        //条目模块
        .list-wrap{

            .item{
                @h:78px;
                height: @h;
                // line-height: 70px;
                border-bottom: 1px solid #d8d8d8;
                position: relative;
                padding:0 @align;
                &:last-child{
                    border-bottom: none;
                }
                .title{
                    line-height: @h;
                    img{
                        vertical-align: middle;
                        margin-right: 30px;
                        width:25px;
                        height:25px;
                    }
                    .text{
                        font-size: 12px;
                        color:#323232;
                    }
                    .special{
                        font-weight: 600;
                        color: @main-c;
                        padding-left: 20px;
                    }

                }

                .func-btn{
                    position:absolute;
                    right: @align;
                    top:50%;
                    transform:translateY(-50%);
                    font-size:0;
                }
            }

            // 前台按钮调整
            .front-btn{
                width:96px;
                font-size:12px;
            }
        }

        // 弹窗部分
        .mid{
            >.el-input{
                max-width:178px;
            }
        }
    }
</style>





// WEBPACK FOOTER //
// page-assets.vue?f33e2ce2